import { render, staticRenderFns } from "./company-info.vue?vue&type=template&id=a32480b4"
import script from "./company-info.vue?vue&type=script&lang=js"
export * from "./company-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports